<template>
    <div>
        <h5>Block Builder</h5>
        <Divider />
        <div class="form-builder-container">
            <div class="form-attributes">
                <div
                    v-for="(attribute, index) in blockBuilderStore.getDroppedAttributes"
                    :key="attribute"
                    class="card my-3"
                    :class="[attribute == blockBuilderStore.getSelectedAttribute ? 'border-dashed' : 'border-1']"
                    @click="previewAttribute(attribute)"
                >
                    <brick :field="attribute" />
                    <div class="buttons">
                        <Button v-if="index !== 0" class="move-up" @click="moveUp(index)">
                            <i class="pi pi-arrow-up"></i>
                        </Button>
                        <Button v-if="index !== blockBuilderStore.getDroppedAttributes?.length - 1" class="move-down" @click="moveDown(index)">
                            <i class="pi pi-arrow-down"></i>
                        </Button>
                        <Button class="remove" @click="removeAttribute(index)">
                            <i class="pi pi-times"></i>
                        </Button>
                    </div>
                </div>
            </div>
            <ScrollTop target="parent" :threshold="50" icon="pi pi-arrow-up" />
        </div>
        <Divider />
        <Button label="Save" icon="pi pi-check" class="ml-2 p-button-primary" @click="submit" />
    </div>
</template>

<script>
import { useBlockBuilderStore } from '@/store/block/block-builder';
import Brick from '../brick/Brick.vue';
import { mapStores } from 'pinia';

export default {
    name: 'FormBuilder',
    components: { Brick },
    emits: ['show-design', 'attributes-block'],
    props: {
        droppedItems: {
            type: Object,
        },
    },
    data() {
        return {
            activeAttribute: {},
        };
    },
    computed: {
        ...mapStores(useBlockBuilderStore),
    },
    methods: {
        submit() {
            if (this.blockBuilderStore.droppedAttributes?.length > 0) {
                this.buildAttributesBlock();
            } else {
                this.$emit('attributes-block', []);
            }
        },
        buildAttributesBlock() {
            const attributes = this.blockBuilderStore.getAttributesList;
            // after building attributes, clean the block builder
            this.blockBuilderStore.droppedAttributes = [];
            this.$emit('attributes-block', attributes);
        },
        previewAttribute(field) {
            this.blockBuilderStore.selectedAttribute = field;
            this.$emit('show-design', field);
        },
        moveUp(index) {
            this.blockBuilderStore.moveAttributeUp(index);
        },
        moveDown(index) {
            this.blockBuilderStore.moveAttributeDown(index);
        },
        removeAttribute(index) {
            this.blockBuilderStore.removeAttribute(index);
        },
    },
};
</script>

<style scoped>
.form-builder-container {
    height: 60vh;
    overflow-y: auto;
}
.form-attributes {
    padding: 12px;
    cursor: pointer;
}
.card {
    position: relative;
}

.buttons {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.buttons > Button {
    background-color: #3f51b5;
    color: #fff;
    padding: 3px 3px;
    margin: auto 2px;
    border-radius: 1px;
    font-size: 0.4em;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s;
}

.buttons > Button:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
    pointer-events: none;
    transition: all 0.3s;
}
.buttons > Button:hover {
    cursor: pointer;
}
.buttons > Button:hover:after {
    transform: translate(-50%, -50%) scale(2);
    opacity: 0;
}
</style>
